var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    id: "Roof",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #aad3c7;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: .54px;\n      }\n\n      .cls-2 {\n        fill: rgba(245, 142, 131, .4);\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15,
    cy: 15,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.35,25.03h1.46c.44,0,.8-.36.8-.79v-1.36c1.17-.17,2.18-.54,3.05-1.1,1.36-.9,2.06-2.14,2.09-3.72.02-.99-.25-1.82-.82-2.51-.92-1.1-2.36-1.79-4.31-2.06v-2.75c.34.16.67.38.99.65.2.16.42.25.68.25.21,0,.5-.14.5-.14h0s1.63-1.03,1.63-1.03c.22-.14.34-.32.34-.54,0-.18-.07-.33-.21-.46-1.02-1.16-2.33-1.88-3.94-2.16v-1.55c0-.44-.36-.8-.8-.8h-1.46c-.44,0-.8.36-.8.8v1.5c-.75.1-1.44.3-2.04.57-1.96.89-2.92,2.23-2.89,4,.02.87.28,1.65.79,2.32.85,1.14,2.24,1.86,4.15,2.15v3.43c-.83-.29-1.61-.83-2.34-1.63-.16-.21-.38-.31-.64-.31-.15,0-.44.13-.44.13h0s-1.49.87-1.49.87c-.25.15-.38.34-.37.58,0,.16.06.3.17.42.39.54.91,1.06,1.56,1.55,1.05.81,2.24,1.31,3.56,1.52v1.35c0,.44.36.79.8.79ZM16.6,16.69c.79.25,1.18.71,1.18,1.38,0,.63-.29,1.11-.86,1.46-.1.06-.21.12-.32.17v-3.01ZM12.59,11.86c0-.49.28-.87.85-1.15l.11-.04v2.43c-.64-.24-.96-.66-.96-1.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.db10b2af34f6cbe93f0d58dfb7e38463.svg";
export { ForwardRef as ReactComponent };